import WarningIconAlert from "../../components/WarningIconAlert";
import { colorsList } from "../../data/colorsList";
import { checkHour } from "../../functions/checkHour";
import { strLang } from "../../functions/strLang";
import RecordTotal from "./RecordTotal";
import MessageIcon from "@mui/icons-material/Message";

export default function ActivityCard({
  data,
  askEdit,
  sBox = "",
  openWarningMsg,
  secondFlex = { active: false, size: false },
}) {
  const { id, status, extraDates, color, name, descrip, hour, person, info } =
    data;

  return (
    <div
      className={
        "activity" +
        sBox +
        (status === 3 && !extraDates ? " activityGreen" + sBox : "") +
        " prevent-select"
      }
      style={{
        backgroundColor: color,
        borderBottom: "solid 1px " + colorsList.grey,
      }}
    >
      <div style={{ display: "flex", flexDirection: "row" }}>
        <b
          style={{ flex: 1, color: colorsList.blue }}
          onClick={() => askEdit({ ...data }, sBox === "2")}
        >
          {name}
        </b>
        {descrip && !secondFlex.active && (
          <div style={{ padding: 5 }}>
            <WarningIconAlert
              text={descrip}
              onClick={() => openWarningMsg({ id, name, descrip, save: false })}
            />
          </div>
        )}
      </div>
      <div onClick={() => askEdit({ ...data }, sBox === "2")}>
        <RecordTotal data={data} />
        {status === 3 && <div>{`${strLang("hour")}: ${checkHour(hour)}`}</div>}
        {extraDates && (
          <>
            <div>{strLang("start") + ": " + checkHour(extraDates.initial)}</div>
            <div>{strLang("end") + ": " + checkHour(extraDates.final)}</div>
          </>
        )}
        {person && <div>{`${strLang("guide")}: ${person}`}</div>}
        {info && (
          <MessageIcon style={{ color: colorsList.red, fontSize: 20 }} />
        )}
      </div>
    </div>
  );
}
